import React from "react"
import MessageScreen from "./MessageScreen"

const InvalidLinkScreen = () => (
  <MessageScreen title="This invite link is invalid or has expired.">
    Please contact your event organizer for a new invite.
  </MessageScreen>
)

export default InvalidLinkScreen
